const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxyZWN0IHk9Ijg1LjMzMSIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzM3Ii8+CjxjaXJjbGUgZmlsbD0iI0Q4MDAyNyIgY3g9IjI1NiIgY3k9IjI1NS45OTQiIHI9Ijk2Ii8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=JP-1d21f6ab.mjs.map
